export enum LoginStatus {
	GUEST = 'guest',
	LOGGED_IN = 'loggedin',
}
